export const minorToMajor = (minorUnits: number): number => minorUnits / 100
